module.exports = __webpack_public_path__ + "img/18.f63e38d7.png";